/** Audit screen filters / sort copy. */
export const auditUiEn = {
  auditFilterPlaceholder: 'Search action, message, trace, actor…',
  auditSortLabel: 'Sort',
  auditSortNewest: 'Newest',
  auditSortOldest: 'Oldest',
  auditSeverityLabel: 'Severity',
  auditSeverityAll: 'All levels',
  auditFamilyLabel: 'Category',
  auditFamilyAll: 'All categories',
  auditResultCount: '{count} events',
  auditResultCountOne: '1 event',
  auditClearFilters: 'Clear filters',
  auditNoMatch: 'No events match these filters.',
  auditStackTrace: 'Stack trace',
  auditExport: 'Export events',
  auditExportDone: 'Audit export ready',
  auditExportCount: '{count} events downloaded',
  auditExportTruncated: '{count} events downloaded (more remain — export again)',
  auditPurge: 'Clear audit log',
  auditPurgeHint: 'Permanent deletion',
  auditPurgeConfirm: 'This permanently deletes every audit event. Export a copy first if you need a backup. Continue?',
  auditPurgeConfirmCta: 'Delete all events',
  auditPurgeDone: 'Audit log cleared',
  auditPurgeCount: '{count} events removed',
} as const;

export const auditUiEs = {
  auditFilterPlaceholder: 'Buscar acción, mensaje, traza, actor…',
  auditSortLabel: 'Orden',
  auditSortNewest: 'Más recientes',
  auditSortOldest: 'Más antiguos',
  auditSeverityLabel: 'Severidad',
  auditSeverityAll: 'Todos los niveles',
  auditFamilyLabel: 'Categoría',
  auditFamilyAll: 'Todas las categorías',
  auditResultCount: '{count} eventos',
  auditResultCountOne: '1 evento',
  auditClearFilters: 'Limpiar filtros',
  auditNoMatch: 'Ningún evento coincide con estos filtros.',
  auditStackTrace: 'Pila de llamadas',
  auditExport: 'Exportar eventos',
  auditExportDone: 'Exportación lista',
  auditExportCount: '{count} eventos descargados',
  auditExportTruncated: '{count} eventos descargados (quedan más — exporta otra vez)',
  auditPurge: 'Limpiar auditoría',
  auditPurgeHint: 'Eliminación permanente',
  auditPurgeConfirm: 'Esto elimina permanentemente todos los eventos de auditoría. Exporta una copia antes si necesitas respaldo. ¿Continuar?',
  auditPurgeConfirmCta: 'Eliminar todos los eventos',
  auditPurgeDone: 'Auditoría limpiada',
  auditPurgeCount: '{count} eventos eliminados',
} as const;
